
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'SupportMenu',
  props: {
    isCollapsed: Boolean,
    activeBgColor: {
      type: String,
      default: 'bg-juniper-500/15'
    },
    hoverBgColor: {
      type: String,
      default: 'hover:bg-juniper-500/10'
    }
  }
})
